import vuetify from './plugins/vuetify'
import store from './store'
import router from './router'
import en from './i18n/en.js'
import { SENTRY_DSN , SENTRY_ENVIRONMENT , VERSION} from "@/config/constants";
import { createApp } from "vue"
import App from './App.vue'

import './assets/css/main.styl'

import { createI18n } from "vue-i18n";

import * as Sentry from "@sentry/vue";
import { BrowserTracing } from "@sentry/tracing";

const app = createApp(App)

const i18n = createI18n({
  legacy: false,
  locale: "en",
  globalInjection: true,
  messages: {
    en
  }
});

Sentry.init({
  app,
  dsn: SENTRY_DSN,
  environment: SENTRY_ENVIRONMENT,
  release: `solo-zoom-app@${VERSION}`,
  integrations: [
    new BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      tracingOrigins: ["https://jeeniezoom.pt-staging.com", "https://zoom.apps.dev.jeenie.com", "https://zoom.apps.jeenie.com", /^\//],
    }),
  ],
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
});
Sentry.setTag("version", VERSION); //for specifying app version

app.use(i18n).use(router).use(vuetify).use(store).mount("#app");
